function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Doctor-Medical_care-Healthcare-VDOcall-Conference-Notebook",
  "data-name": "Doctor-Medical care-Healthcare-VDOcall-Conference-Notebook"
}, /*#__PURE__*/React.createElement("path", {
  d: "m55 13v28a2.006 2.006 0 0 1 -2 2h-42a2.006 2.006 0 0 1 -2-2v-28z",
  fill: "#46f8ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m55 13v28a2.006 2.006 0 0 1 -2 2h-4a2.006 2.006 0 0 0 2-2v-28z",
  fill: "#00e7f0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.23 61h-52.46a2 2 0 0 1 -1.89-2.63l4.66-14a2.009 2.009 0 0 1 1.9-1.37h43.12a2.009 2.009 0 0 1 1.9 1.37l4.66 14a2 2 0 0 1 -1.89 2.63z",
  fill: "#898890"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.23 61h-4a2 2 0 0 0 1.89-2.63l-4.66-14a2.009 2.009 0 0 0 -1.9-1.37h4a2.009 2.009 0 0 1 1.9 1.37l4.66 14a2 2 0 0 1 -1.89 2.63z",
  fill: "#787680"
}), /*#__PURE__*/React.createElement("path", {
  d: "m55 20.48a8.8 8.8 0 0 1 -3 .52 8.994 8.994 0 0 1 -8.94-8.01 8.22 8.22 0 0 1 -.06-.99 9 9 0 1 1 12 8.48z",
  fill: "#c6c5ca"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61 12a8.981 8.981 0 0 1 -6 8.48 8.8 8.8 0 0 1 -3 .52 8.934 8.934 0 0 1 -2.02-.23 7.008 7.008 0 0 0 1.02-.29 9 9 0 0 0 -1-17.26 9.356 9.356 0 0 1 2-.22 9 9 0 0 1 9 9z",
  fill: "#acabb1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m39.15 28.83.85 10.17h-16l.85-10.17a1.994 1.994 0 0 1 1.99-1.83h1.03a2 2 0 0 1 1.71.97l2.42 4.03 2.42-4.03a2 2 0 0 1 1.71-.97h1.03a1.994 1.994 0 0 1 1.99 1.83z",
  fill: "#e0e0e2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40 39h-4l-.85-10.17a1.945 1.945 0 0 0 -.5-1.16 1.963 1.963 0 0 1 1.48-.67h1.03a1.994 1.994 0 0 1 1.99 1.83z",
  fill: "#c6c5ca"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35 20v2a3 3 0 0 1 -6 0v-2a3 3 0 0 1 6 0z",
  fill: "#ffc477"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35 20v2a3 3 0 0 1 -4.5 2.6 3 3 0 0 0 1.5-2.6v-2a2.993 2.993 0 0 0 -.88-2.12 3.3 3.3 0 0 0 -.62-.48 3.026 3.026 0 0 1 1.5-.4 3 3 0 0 1 3 3z",
  fill: "#ffa733"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27 5v12a2.006 2.006 0 0 1 -2 2h-7v4l-4-4h-9a2.006 2.006 0 0 1 -2-2v-12a2.006 2.006 0 0 1 2-2h20a2.006 2.006 0 0 1 2 2z",
  fill: "#c6c5ca"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27 5v12a2.006 2.006 0 0 1 -2 2h-5a2.006 2.006 0 0 0 2-2v-12a2.006 2.006 0 0 0 -2-2h5a2.006 2.006 0 0 1 2 2z",
  fill: "#acabb1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23 7v8l-4-3v-2z",
  fill: "#806749"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19 12v1a2.006 2.006 0 0 1 -2 2h-8a2.006 2.006 0 0 1 -2-2v-4a2.006 2.006 0 0 1 2-2h8a2.006 2.006 0 0 1 2 2z",
  fill: "#a78966"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 2h-20a3.009 3.009 0 0 0 -3 3v12a3.009 3.009 0 0 0 3 3h8.59l3.7 3.71a1.007 1.007 0 0 0 .71.29.838.838 0 0 0 .38-.08.987.987 0 0 0 .62-.92v-3h6a3.009 3.009 0 0 0 3-3v-12a3.009 3.009 0 0 0 -3-3zm1 15a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v1.59l-2.29-2.3a1.033 1.033 0 0 0 -.71-.29h-9a1 1 0 0 1 -1-1v-12a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52 2a10 10 0 1 0 10 10 10.016 10.016 0 0 0 -10-10zm0 18a8 8 0 1 1 8-8 8.011 8.011 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38 56h-12a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.986 14h8.014a1 1 0 0 0 0-2h-8.014a1 1 0 0 0 0 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61.07 58.05-4.67-14a2.99 2.99 0 0 0 -.93-1.35 3.029 3.029 0 0 0 .53-1.7v-16a1 1 0 0 0 -2 0v16a1 1 0 0 1 -1 1h-42a1 1 0 0 1 -1-1v-17.98a1 1 0 1 0 -2 0v17.98a3.029 3.029 0 0 0 .53 1.7 2.99 2.99 0 0 0 -.93 1.35l-4.67 14a3 3 0 0 0 2.84 3.95h52.46a3 3 0 0 0 2.84-3.95zm-2.03 1.53a.983.983 0 0 1 -.81.42h-52.46a.983.983 0 0 1 -.81-.42.963.963 0 0 1 -.13-.9l4.66-14a1 1 0 0 1 .95-.68h43.12a1 1 0 0 1 .95.68l4.66 14a.963.963 0 0 1 -.13.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 22a4 4 0 0 0 8 0v-2a4 4 0 0 0 -8 0zm2-2a2 2 0 0 1 4 0v2a2 2 0 0 1 -4 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.15 28.75a3.019 3.019 0 0 0 -2.99-2.75h-1.03a3.009 3.009 0 0 0 -2.57 1.46l-1.56 2.6-1.56-2.6a3.009 3.009 0 0 0 -2.57-1.46h-1.03a3.019 3.019 0 0 0 -2.99 2.75l-.85 10.17a1.013 1.013 0 0 0 .26.76 1.029 1.029 0 0 0 .74.32h16a1.029 1.029 0 0 0 .74-.32 1.013 1.013 0 0 0 .26-.76zm-15.06 9.25.75-9.08a1.01 1.01 0 0 1 1-.92h1.03a1.012 1.012 0 0 1 .86.49l2.41 4.02a1.037 1.037 0 0 0 1.72 0l2.41-4.02a1.012 1.012 0 0 1 .86-.49h1.03a1.01 1.01 0 0 1 1 .92l.75 9.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.45 6.11a1 1 0 0 0 -1.05.09l-2.55 1.91a2.992 2.992 0 0 0 -2.85-2.11h-8a3.009 3.009 0 0 0 -3 3v4a3.009 3.009 0 0 0 3 3h8a2.992 2.992 0 0 0 2.85-2.11l2.55 1.91a.99.99 0 0 0 1.05.09.988.988 0 0 0 .55-.89v-8a.988.988 0 0 0 -.55-.89zm-5.45 6.89a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1-1v-4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1zm4 0-2-1.5v-1l2-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58 12a1 1 0 0 1 -1 1h-4v4a1 1 0 0 1 -2 0v-4h-4a1 1 0 0 1 0-2h4v-4a1 1 0 0 1 2 0v4h4a1 1 0 0 1 1 1z"
}));

var SvgDoctor = function SvgDoctor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoctor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doctor.894a7951.svg";
export { ForwardRef as ReactComponent };